// Centralised route definitions — single source of truth for navigation
export const ROUTES = {
  HOME: '/',
  TESTS: '/tests',
  TEST_DETAIL: '/tests/:id',
  PACKAGES: '/packages',
  PACKAGE_DETAIL: '/packages/:id',
  SPECIALS: '/specials',
  MEMBERSHIP: '/membership',
  ABOUT: '/about',
  BLOG: '/blog',
  BLOG_ARTICLE: '/blog/:slug',
  FAQ: '/faq',
  SUPPORT: '/support',
  CENTRES: '/centres',
  DOCTORS: '/doctors',
  PRIVACY: '/privacy',
  // Bare privacy policy (no navbar / footer) — submitted to Play Store
  // & App Store as the mobile app's privacy URL.
  APP_PRIVACY: '/app-privacy',
  // Smart app-download link — the URL the printed QR code encodes.
  // Sends Android to Play Store and iPhone to the App Store. Keep the
  // path short and NEVER rename it: every QR already printed points here.
  APP_DOWNLOAD: '/app',
  CAREERS: '/careers',
  CORPORATE: '/corporate',
  CART: '/cart',
  BOOKING: '/booking',
  CANCEL_BOOKING: '/booking/:id/cancel',
  TRACK: '/track',
  LOGIN: '/login',
  SIGNUP: '/signup',
  REPORTS: '/reports',
  MY_TICKETS: '/my-tickets',
  DASHBOARD: '/dashboard',
  MED_DASHBOARD: '/portal/medical',
  LAB_DASHBOARD: '/portal/lab',
  CORP_DASHBOARD: '/portal/corporate',
  QA_PORTAL: '/portal/qa',
  ADMIN: '/portal/admin',
  SITE_ADMIN: '/site-admin',
};

// Helper for navigation with params
export const buildRoute = (route, params = {}) => {
  let path = route;
  Object.entries(params).forEach(([key, value]) => {
    path = path.replace(`:${key}`, value);
  });
  return path;
};
